import React, { Component } from "react";
import "./css/dashboard.css";
import MoneyCard from "../common/Money-card";
import Appointment from "../common/Appointment";
import AppointmentCard from "../common/Appointment_card";
import { NavLink } from "react-router-dom";
import Task from "../common/Task";
import { connect } from "react-redux";
import { StatsContext } from "../contexts/StatsContext";
import { getDateData } from "../common/HelperFunctions";
import nobooking from "../assets/nobooking.svg";
import copy from "../assets/copy2.png";

const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
  headers: { headers: state.headers() },
  business: state.business,

});

function numberWithCommas(x, zeros) {

  zeros = zeros ?? 2;

  return (x).toFixed(zeros).replace(/\d(?=(\d{3})+\.)/g, '$&,');

}

function formatMoney(number) {
  return (number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


export default connect(mapStateToProps)(
  class Dashboard extends Component {
    static contextType = StatsContext;
    state = {
      link: `https://${window.location.host}/`,
      authCode: null,
    };


    render() {

      const queryParams = new URLSearchParams(window.location.search);
      const code = queryParams.get("code");
      if (code) {
        this.setState({ authCode: code });
        // Optional: clean the URL by removing the query string
        const cleanUrl =
          window.location.origin + "/business/profile/integration"
          + "?code=" +
          code;
        console.log(cleanUrl);

        window.location.href = cleanUrl;

      }
      const { stats, sortedBookings_byDate } = this.context;
      const user = this.props.userProfile;

      return stats?.bookings ? (
        <div className="dashboard-page">
          {user?.account_type !== "business_team_member" ? (
            <div className="cash-container">
              <div className="money-cards">
                <MoneyCard
                  title="Bookings (This Month)"
                  value={`${stats.number_of_bookings_month
                    ? numberWithCommas(stats.number_of_bookings_month, 0)
                    : 0
                    }`}
                />
                <MoneyCard
                  title="Income (This Month)"
                  value={`₦${stats.total_made_month ? numberWithCommas(stats.total_made_month) : 0
                    }`}
                />


                <MoneyCard
                  title="Bookings (All-time)"
                  value={`${stats.number_of_bookings
                    ? numberWithCommas(stats.number_of_bookings, 0)
                    : 0
                    }`}
                />
                <MoneyCard
                  title="Income (All-time)"
                  value={`₦${stats.total_made ? numberWithCommas(stats.total_made) : 0
                    }`}
                />

                {/* <MoneyCard
                  title="Pending payout"
                  value={`₦${
                    stats.wallet_balance
                      ? numberWithCommas(stats.wallet_balance)
                      : 0
                  }`}
                /> */}
              </div>
              {/* <div className="wrapper">
                <NavLink
                  to={{ pathname: "/payments" }}
                  className="co-pink link"
                >
                  See all payments
                </NavLink>
              </div> */}
            </div>
          ) : null}

          <div>

            <div class="card cardlink">
              <div >
                <span style={{ fontWeight: '100', color: '#5d6c76' }} >

                  <span className="linktitle">Your booking link:</span>
                  <b className="wrapMobile">{
                    `https://kindlybook.me/${this.props.business.username}`
                  }</b>
                </span>
                <span className="copyb">

                  <button
                    className="co-pink copy-btn flex"
                    onClick={window.copiedLink}
                    data-clipboard-text={
                      `https://kindlybook.me/${this.props.business.username}`
                    }
                  >
                    <img src={copy} alt="" style={{ marginRight: '10px', width: '20px' }} />
                    Copy Link
                  </button>
                </span>

              </div>
            </div>
          </div>
          <div className="wrapper bookings section">
            <div className="section-header flex space-btw">
              <p className="section-title">Bookings</p>
              <NavLink to={{ pathname: "/bookings" }} className="co-pink link">
                See all bookings
              </NavLink>
            </div>

            {Object.keys({ ...sortedBookings_byDate }).map((date, index) => (
              <Appointment
                key={index}
                {...getDateData(sortedBookings_byDate[date][0].date)}
              >
                {sortedBookings_byDate[date].map((booking, index) => (
                  <AppointmentCard {...booking} key={index} />
                ))}
              </Appointment>
            ))}
            {/* empty state */}
            {Object.keys({ ...sortedBookings_byDate }).length <= 0 ? (
              <div className="emptyState">
                <img src={nobooking} alt="" />
                <p>
                  Upcoming appointments will show up here when customers start booking your services
                </p>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.props.userProfile?.account_type !== "business_team_member" ? (
            <Tasks />
          ) : (
            ""
          )}
        </div>
      ) :
        (
          <div className="dashboard-page">
            {!this.props.userProfile?.invite_accepted && this.props.userProfile?.account_type === "business_team_member" ? (
              <>
                <div
                  className="card-container pending-invite-card">
                  <div className="card">
                    <div>
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M19.9987 36.6667C29.2034 36.6667 36.6654 29.2048 36.6654 20C36.6654 10.7953 29.2034 3.33337 19.9987 3.33337C10.794 3.33337 3.33203 10.7953 3.33203 20C3.33203 29.2048 10.794 36.6667 19.9987 36.6667Z" fill="#6E7E8F" />
                        <rect x="18.332" y="16.6666" width="3.33333" height="11.6667" rx="1" fill="#6E7E8F" />
                        <rect x="18.332" y="11.6666" width="3.33333" height="3.33333" rx="1" fill="#6E7E8F" />
                      </svg>
                    </div>
                    <div className="title">Awaiting Approval</div>
                    <p>Tell the account owner to approve your request</p>
                  </div>
                </div>
              </>
            ) : null}
          </div>)
    }
  }
);

// function

function Tasks() {
  return (
    <div className="section wrapper tasks">
      <div className="section-header flex space-btw">
        <p className="section-title">Tasks</p>
      </div>
      <div className="tasks-links">
        <NavLink to={{ pathname: "/team" }}>
          <Task
            title="Manage team members"
            svg={
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.00008 8.16669C10.1052 8.16669 11.165 8.60567 11.9464 9.38708C12.7278 10.1685 13.1667 11.2283 13.1667 12.3334V17.3334H4.83342V12.3334C4.83342 11.2283 5.2724 10.1685 6.0538 9.38708C6.83521 8.60567 7.89501 8.16669 9.00008 8.16669ZM3.40675 10.6717C3.27413 11.119 3.19579 11.5807 3.17341 12.0467L3.16675 12.3334V17.3334H0.666748V13.5834C0.666584 12.8647 0.931772 12.1712 1.41144 11.636C1.89112 11.1008 2.5515 10.7616 3.26591 10.6834L3.40758 10.6717H3.40675ZM14.5934 10.6717C15.335 10.7169 16.0314 11.0433 16.5406 11.5844C17.0497 12.1254 17.3333 12.8404 17.3334 13.5834V17.3334H14.8334V12.3334C14.8334 11.7559 14.7501 11.1984 14.5934 10.6717ZM3.58341 5.66669C4.13595 5.66669 4.66585 5.88618 5.05655 6.27688C5.44725 6.66758 5.66675 7.19749 5.66675 7.75002C5.66675 8.30256 5.44725 8.83246 5.05655 9.22316C4.66585 9.61386 4.13595 9.83335 3.58341 9.83335C3.03088 9.83335 2.50098 9.61386 2.11028 9.22316C1.71957 8.83246 1.50008 8.30256 1.50008 7.75002C1.50008 7.19749 1.71957 6.66758 2.11028 6.27688C2.50098 5.88618 3.03088 5.66669 3.58341 5.66669ZM14.4167 5.66669C14.9693 5.66669 15.4992 5.88618 15.8899 6.27688C16.2806 6.66758 16.5001 7.19749 16.5001 7.75002C16.5001 8.30256 16.2806 8.83246 15.8899 9.22316C15.4992 9.61386 14.9693 9.83335 14.4167 9.83335C13.8642 9.83335 13.3343 9.61386 12.9436 9.22316C12.5529 8.83246 12.3334 8.30256 12.3334 7.75002C12.3334 7.19749 12.5529 6.66758 12.9436 6.27688C13.3343 5.88618 13.8642 5.66669 14.4167 5.66669ZM9.00008 0.666687C9.88414 0.666687 10.732 1.01788 11.3571 1.643C11.9822 2.26812 12.3334 3.11597 12.3334 4.00002C12.3334 4.88408 11.9822 5.73192 11.3571 6.35704C10.732 6.98216 9.88414 7.33335 9.00008 7.33335C8.11603 7.33335 7.26818 6.98216 6.64306 6.35704C6.01794 5.73192 5.66675 4.88408 5.66675 4.00002C5.66675 3.11597 6.01794 2.26812 6.64306 1.643C7.26818 1.01788 8.11603 0.666687 9.00008 0.666687Z"
                  fill="#2A2B79"
                />
              </svg>
            }
          />
        </NavLink>

        <NavLink to={{ pathname: "/services/settings" }}>
          <Task
            title="Manage services"
            svg={
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.666748 12H6.50008V13.6666H0.666748V12ZM0.666748 6.16665H8.16675V7.83331H0.666748V6.16665ZM0.666748 0.333313H17.3334V1.99998H0.666748V0.333313ZM16.2284 7.85415L17.1917 7.52831L18.0251 8.97165L17.2617 9.64248C17.3578 10.098 17.3578 10.5686 17.2617 11.0241L18.0251 11.695L17.1917 13.1383L16.2284 12.8125C15.8867 13.1208 15.4801 13.3583 15.0326 13.5041L14.8334 14.5H13.1667L12.9667 13.5033C12.5245 13.3588 12.1174 13.1232 11.7717 12.8116L10.8084 13.1383L9.97508 11.695L10.7384 11.0241C10.6423 10.5686 10.6423 10.098 10.7384 9.64248L9.97508 8.97165L10.8084 7.52831L11.7717 7.85415C12.1134 7.54581 12.5201 7.30831 12.9676 7.16248L13.1667 6.16665H14.8334L15.0334 7.16331C15.4801 7.30831 15.8867 7.54665 16.2284 7.85498V7.85415ZM14.0001 11.1666C14.2211 11.1666 14.4331 11.0788 14.5893 10.9226C14.7456 10.7663 14.8334 10.5543 14.8334 10.3333C14.8334 10.1123 14.7456 9.90034 14.5893 9.74406C14.4331 9.58778 14.2211 9.49998 14.0001 9.49998C13.7791 9.49998 13.5671 9.58778 13.4108 9.74406C13.2545 9.90034 13.1667 10.1123 13.1667 10.3333C13.1667 10.5543 13.2545 10.7663 13.4108 10.9226C13.5671 11.0788 13.7791 11.1666 14.0001 11.1666Z"
                  fill="#2A2B79"
                />
              </svg>
            }
          />
        </NavLink>

        <NavLink to={{ pathname: "/bookings/settings" }}>
          <Task
            title="Manage booking settings"
            svg={
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.16659 0.666687H12.8333C13.0543 0.666687 13.2662 0.754484 13.4225 0.910765C13.5788 1.06704 13.6666 1.27901 13.6666 1.50002V17.4525C13.6667 17.527 13.6468 17.6002 13.609 17.6644C13.5712 17.7286 13.5169 17.7815 13.4517 17.8176C13.3865 17.8537 13.3129 17.8716 13.2384 17.8696C13.1639 17.8675 13.0913 17.8455 13.0282 17.8059L6.99992 14.025L0.971585 17.805C0.908558 17.8446 0.836075 17.8666 0.76167 17.8687C0.687266 17.8708 0.613657 17.8529 0.548498 17.817C0.483339 17.781 0.429008 17.7282 0.391154 17.6641C0.353301 17.6 0.333307 17.527 0.333252 17.4525V1.50002C0.333252 1.27901 0.421049 1.06704 0.57733 0.910765C0.73361 0.754484 0.945571 0.666687 1.16659 0.666687ZM3.66658 6.50002V8.16669H10.3333V6.50002H3.66658Z"
                  fill="#2A2B79"
                />
              </svg>
            }
          />
        </NavLink>

        {/* <NavLink to={{ pathname: "/bookings/opening_hours" }}>
          <Task
            title="Opening Hours"
            svg={
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.16659 0.666687H12.8333C13.0543 0.666687 13.2662 0.754484 13.4225 0.910765C13.5788 1.06704 13.6666 1.27901 13.6666 1.50002V17.4525C13.6667 17.527 13.6468 17.6002 13.609 17.6644C13.5712 17.7286 13.5169 17.7815 13.4517 17.8176C13.3865 17.8537 13.3129 17.8716 13.2384 17.8696C13.1639 17.8675 13.0913 17.8455 13.0282 17.8059L6.99992 14.025L0.971585 17.805C0.908558 17.8446 0.836075 17.8666 0.76167 17.8687C0.687266 17.8708 0.613657 17.8529 0.548498 17.817C0.483339 17.781 0.429008 17.7282 0.391154 17.6641C0.353301 17.6 0.333307 17.527 0.333252 17.4525V1.50002C0.333252 1.27901 0.421049 1.06704 0.57733 0.910765C0.73361 0.754484 0.945571 0.666687 1.16659 0.666687ZM3.66658 6.50002V8.16669H10.3333V6.50002H3.66658Z"
                  fill="#2A2B79"
                />
              </svg>
            }
          />
        </NavLink> */}
      </div>
    </div>
  );
}
